import { axios } from '~/plugins/axios'

function unwrapItem(payload) {
  if (payload && payload.data != null && !Array.isArray(payload.data)) {
    return { ...payload.data, message: payload.message }
  }
  return payload
}

const actions = {
  async fetchFilterOptions() {
    const resp = await axios.get('/api/saved-margin-reports/filter-options')
    return resp.data.data || []
  },

  async fetchReports(_, { packages, projects, page = 1, perPage = 15, period = null }) {
    const params = {
      per_page: perPage,
      page,
    }

    if (packages && packages.length) {
      params.packages = packages
    }

    if (projects && projects.length) {
      params.projects = projects
    }

    if (period && period.length) {
      params.period = period
    }

    const resp = await axios.get('/api/saved-margin-reports', { params })
    return resp.data
  },

  async fetchReport(_, reportId) {
    const resp = await axios.get(`/api/saved-margin-reports/${reportId}`)
    return unwrapItem(resp.data)
  },

  async saveReport(_, payload) {
    await axios.post('/api/saved-margin-reports', payload)
  },

  async updateReport(_, { reportId, data }) {
    const resp = await axios.patch(`/api/saved-margin-reports/${reportId}`, data)
    return unwrapItem(resp.data)
  },

  async deleteReport(_, reportId) {
    const resp = await axios.delete(`/api/saved-margin-reports/${reportId}`)
    return resp.data
  },
}

export default {
  namespaced: true,
  actions,
}
